import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { Form } from "react-bootstrap";
import { Container, Row, Col } from "react-bootstrap";
import { ChevronDown } from "styled-icons/boxicons-regular";
import {
  InputNum,
  InputText,
  ReactSimpleRadioButton,
} from "../../../Shared/FormFields";
import ClickOutside from "react-simple-click-outside";
import DatePicker from "react-datepicker";
import Calendar from "../calendar.png";
import { User } from "styled-icons/boxicons-solid/User";
import { addManagerEmployee, updateManagerEmployee } from "../../../../Actions";
import { format } from "date-fns";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
} from "styled-dropdown-component";
import { withTranslation, Trans } from "react-i18next";
import { dateFormat } from "../../../../Api/Utils/ReuseableFunctions";

class OnBoardForm extends Component {
  constructor(props) {
    super(props);
    let formData = props.empoyeeData ? props.empoyeeData : null;
    this.startDate = formData
      ? formData.startDate
        ? dateFormat(formData.startDate)
        : new Date()
      : new Date();
    this.endDate = formData
      ? formData.endDate
        ? dateFormat(formData.endDate)
        : null
      : null;
    this.state = {
      skillHide: true,
      isGoing: true,
      hidden: true,
      shiftList: undefined,
      formData: {
        ssoId: formData ? formData.ssoId : "",
        firstName: formData ? formData.firstName : "",
        lastName: formData ? formData.lastName : "",
        emailId: formData ? formData.emailId : "",
        notes: formData ? formData.notes : "",
        shiftAllocation: formData ? formData.shiftAllocation : "",
        startDate: formData ? formData.startDate : "",
        endDate: formData ? formData.endDate : "",
        workHours: formData ? formData.workHours : "",
        shiftId: formData ? formData.shiftId : "",
        skill: formData ? formData.skill : "",
        maintUser: this.props.ssoId,
        allocationPercentage: formData.allocationPercentage ? formData.allocationPercentage : ""
      },
      shiftAllocation: formData
        ? formData.shiftAllocation
          ? formData.shiftAllocation
          : ""
        : "",
    };
  }
  skillOpenClose = () => {
    this.setState(state => ({ skillHide: !state.skillHide }));
  };
  close = () => {
    this.setState({ skillHide: true });
  };
  componentDidMount() {
    this.setState({
      shiftList: this.props.shiftList,
      skillList: this.props.skillList
    });
  }

  handleFormChange = (data, name) => {
    let formData = this.state.formData;
    if (name === "startDate" || name === "endDate") {
      if (name === "startDate") {
        this.startDate = data;
        this.endDate = null;
      } else {
        this.endDate = data;
      }
    } else if (name === "workHours") {
      formData[name] = this.props.workHours.indexOf(data) + 1;
      this.changeShiftAsPerWorkhours(formData[name]);
      this.setState({ formData });
    } else if (name === "allocationPercentage") {
      if (0 <= Number(data) && Number(data) <= 100) {
        formData[name] = Number(data);

        this.setState({ formData });
      }

    } else {
      formData[name] = data;

      this.setState({ formData });
    }
    formData.startDate = format(this.startDate, "dd/MM/yyyy");
    formData.endDate = this.endDate ? format(this.endDate, "dd/MM/yyyy") : null;
  };

  _close = (target) => {
    this.setState({
      [target]: true,
    });
  };

  handleOpenCloseDropdown() {
    this.setState({
      hidden: !this.state.hidden,
    });
  }

  handleSubmit(e) {
    e.preventDefault();
  }
  filterSkillList = (formData) => {
    let skillData = this.props.skillList.filter((skillData) => {
      return Number(skillData.id) === Number(formData.skill);
    });
    return skillData;
  };
  filterShiftList = (formData) => {
    let shiftData = this.state.shiftList.filter((shiftData) => {
      return Number(shiftData.shiftId) === Number(formData.shiftId);
    });

    return shiftData;
  };
  changeShiftAsPerWorkhours(id) {
    if (id === 1 || id === 2) {
      let filterShift = this.state.shiftList.filter(
        (shiftData) => Number(shiftData.shiftId) === id
      )[0];
      filterShift && this.selectShiftData(filterShift);
    }
  }
  selectSkillData = (skillData) => {
    let formData = this.state.formData;
    formData.skill = parseInt(skillData.id);
    formData.skilldesc =
      skillData.description;
    this.setState({
      skill:
        skillData.description,
        skillHide: !this.state.skillHide,
      formData,
    });
  };
  selectShiftData = (shiftData) => {
    let formData = this.state.formData;
    formData.shiftId = parseInt(shiftData.shiftId);
    formData.shiftAllocation =
      shiftData.shiftPlan +
      "   " +
      shiftData.shiftStartTime +
      "-" +
      shiftData.shiftEndTime;
    this.setState({
      shiftAllocation:
        shiftData.shiftPlan +
        "   " +
        shiftData.shiftStartTime +
        "-" +
        shiftData.shiftEndTime,
      hidden: !this.state.hidden,
      formData,
    });
  };

  Save = () => {
    let payload = this.state.formData;
    this.props.empoyeeData === void 0
      ? this.props.dispatch(addManagerEmployee(payload))
      : this.props.dispatch(updateManagerEmployee(payload));
    this.props.onClose();
  };

  render() {
    const { t, workHours, onClose } = this.props;
    const { formData, shiftList, hidden } = this.state;
    return shiftList !== void 0 ? (
      <>
        <Form onSubmit={this.handleSubmit}>
          <Wrapper>
            <Cont>
              <RowCont>
                <Column lg={2} md={2} sm={2}>
                  {/* <Span>Employee Name 1</Span> */}
                  <UserDiv>
                    <User className="userPic" size="120" />
                  </UserDiv>
                </Column>
                <Column lg={10} md={10} sm={10}>
                  <RowCont>
                    <Column lg="4" md="4" sm="4">
                      <InputNum
                        label={t("sso")}
                        name="ssoId"
                        value={formData.ssoId}
                        editMode={false}
                        handleChange={(e) =>
                          this.handleFormChange(e.target.value, e.target.name)
                        }
                        style={Timefield}
                      />
                    </Column>
                    <Column lg="4" md="4" sm="4">
                      <InputText
                        label={t("name")}
                        name="firstName"
                        value={formData.firstName}
                        editMode={false}
                        handleChange={(e) =>
                          this.handleFormChange(e.target.value, e.target.name)
                        }
                      />
                    </Column>
                    {/* <Column lg="4" md="4" sm="4">
                      <InputText
                        label={t("role")}
                        name="role"
                        value={formData.role}
                        editMode={false}
                        handleChange={(e) =>
                          this.handleFormChange(e.target.value, e.target.name)
                        }
                      />
                    </Column> */}
                    <Column lg="4" md="4" sm="4">
                      <label style={{ paddingLeft: "4px" }}>
                      <Trans>skill</Trans>{" "}
                      </label>
                      <ClickOutside close={this.close} >
                        <Dropdown onClick={() => this.skillOpenClose()} style={skillDropDown}>
                          <label style={skillLabel}>
                            {this.filterSkillList(formData).length > 0 ? (
                              this.filterSkillList(formData).map(
                                (data) =>
                                  data.description
                              )
                            ) : (
                              <Trans>selectSkill</Trans>
                            )}
                            <Chevrondown size="20" />
                          </label>
                          <DropdownMenu
                            hidden={this.state.skillHide}
                            onClick={() => this.skillOpenClose()}
                            style={skillDropMenu}
                          > {this.state.skillList.map((skillData) => (
                            <DropdownItem
                              onClick={() => this.selectSkillData(skillData)
                              }
                              key={skillData.id}
                            >
                              {skillData.description}
                            </DropdownItem>
                          ))}
                          </DropdownMenu>
                        </Dropdown>
                      </ClickOutside>
                    </Column>
                  </RowCont>
                  <RowCont>
                    <Column className="allocationDiv" lg="8" md="8" sm="8">
                      <Column className="allocationDiv" lg="6" md="6" sm="6">
                        <CheckboxDiv>
                          <ReactSimpleRadioButton
                            onChange={(data) =>
                              this.handleFormChange(data, "workHours")
                            }
                            options={workHours}
                            defaultSelected={
                              this.state.formData.workHours
                                ? workHours[this.state.formData.workHours - 1]
                                : workHours[0]
                            }
                          />
                        </CheckboxDiv>
                      </Column>
                      <Column className="allocationDiv" lg="3" md="3" sm="3" >
                        <InputText

                          label={t("available")}
                          name="allocationPercentage"
                          value={formData.allocationPercentage}
                          editMode={true}
                          handleChange={(e) =>
                            this.handleFormChange(e.target.value, e.target.name)
                          }
                          style={TextField}


                        />
                      </Column>

                    </Column>
                    <Column lg="4" md="4" sm="4">
                      <InputText
                        label={t("email")}
                        name="emailId"
                        value={formData.emailId ? formData.emailId : ""}
                        editMode={false}
                        handleChange={(e) =>
                          this.handleFormChange(e.target.value, e.target.name)
                        }
                      />
                    </Column>
                  </RowCont>
                  <RowCont>
                    <ColumnNote lg={4} md={4} sm={4}>
                      <InputText
                        label={t("notes")}
                        name="notes"
                        value={formData.notes || ""}
                        editMode={true}
                        handleChange={(e) =>
                          this.handleFormChange(e.target.value, e.target.name)
                        }
                      />
                    </ColumnNote>
                    {/* <Column lg={4} md={4} sm={4}>
                      <label style={{ paddingLeft: "4px" }}>
                        <Trans>shiftAllocation</Trans>{" "}
                      </label>
                      {Number(this.state.formData.workHours) !== 2 ? (
                        <ClickOutside close={this._close} target="hidden">
                          <DropDown>
                            <Label
                              onClick={() => this.handleOpenCloseDropdown()}
                            >
                              {this.filterShiftList(formData).length > 0 ? (
                                this.filterShiftList(formData).map(
                                  (data) =>
                                    data.shiftPlan +
                                    " " +
                                    data.shiftStartTime +
                                    " " +
                                    "-" +
                                    " " +
                                    data.shiftEndTime
                                )
                              ) : (
                                  <Trans>selectShift</Trans>
                                )}
                              <Chevrondown size="20" />
                            </Label>

                            <DropDownMenu hidden={hidden}>
                              {this.state.shiftList.map((shiftData) => (
                                <DropdownItem
                                  onClick={() =>
                                    this.selectShiftData(shiftData)
                                  }
                                  key={shiftData.shiftId}
                                >
                                  {shiftData.shiftPlan}{" "}
                                  {shiftData.shiftStartTime}
                                  {"-"}
                                  {shiftData.shiftEndTime}
                                </DropdownItem>
                              ))}
                            </DropDownMenu>
                          </DropDown>
                        </ClickOutside>
                      ) : (
                          <div style={{ paddingLeft: "4px" }}>
                            {this.state.shiftAllocation}
                          </div>
                        )}
                    </Column> */}
                    <Column lg={4} md={4} sm={4}>
                      <DateDiv>
                        <StartDateDiv>
                          <Span>
                            <Trans>startDate</Trans>
                          </Span>
                          <DatePickerDiv
                            customInput={
                              <div className="DateValue">
                                {" "}
                                {format(this.startDate, "d MMM yyyy")}{" "}
                              </div>
                            }
                            dateFormat="d MMM yyyy"
                            selected={this.startDate}
                            // minDate={new Date()}
                            selectedDate={new Date()}
                            onChange={(data) =>
                              this.handleFormChange(data, "startDate")
                            }
                            openToDate={new Date()}

                          //disabled={true}
                          />
                          <ImageSpan>
                            <Img src={Calendar} alt="Calendar" />
                          </ImageSpan>
                        </StartDateDiv>
                        <EndDateDiv>
                          <Span>
                            <Trans>endDate</Trans>
                          </Span>
                          <DatePickerDiv
                            customInput={
                              <div className="DateValue">
                                {" "}
                                {this.endDate
                                  ? format(this.endDate, "d MMM yyyy")
                                  : null}{" "}
                              </div>
                            }
                            dateFormat="d MMM yyyy"
                            selected={this.endDate}
                            minDate={this.startDate}
                            selectedDate={this.endDate}
                            onChange={(data) =>
                              this.handleFormChange(data, "endDate")
                            }
                          />
                          <ImageSpan>
                            <Img src={Calendar} alt="Calendar" />
                          </ImageSpan>
                        </EndDateDiv>
                      </DateDiv>
                    </Column>
                  </RowCont>
                </Column>
              </RowCont>
            </Cont>
          </Wrapper>
          <FooterDiv>
            <Btn onClick={onClose}>
              <Trans>cancel</Trans>
            </Btn>
            <BtnSave onClick={this.Save} type="submit">
              <Trans>submit</Trans>
            </BtnSave>
          </FooterDiv>
        </Form>
      </>
    ) : (
        <div />
      );
  }
}

const mapStateToProps = ({ auth, userMessage, managerTimesheetData }) => {
  return {
    isAuthenticated: auth.isAuthenticated,
    ssoId: auth.ssoId,
    message: userMessage,
    userDefault: auth.user.defaultProfile,
    shiftList: managerTimesheetData.payload.shiftList,
    skillList: managerTimesheetData.payload.technicianTypeList
  };
};

export default connect(mapStateToProps)(withTranslation()(OnBoardForm));
const Label = styled.label`
  width: 100%;
  height: 13px;
  margin-bottom: 0px;
  padding-left: 4px;
`;
const TextField = {
  width: "100%",
  position: "relative",
  border: "none",
  borderBottom: "1px solid #6c757d7a",
  outline: "none",
  padding: "0px,0px,0px,0px",
  height: "30px",
  overflowY: "scroll",
};
const DropDown = styled(Dropdown)`
position : relative
//top:5%
border-bottom: 1px solid #b2b7be;`;
const Chevrondown = styled(ChevronDown)`
  position: absolute;
  left: 93%;
`;
const skillDropDown = {
  position: "relative",
  borderBottom: "1px solid #b2b7be"
};
const skillLabel = {
  marginBottom: "0px",
  paddingLeft:"4px"
};
const skillDropMenu = {
  overflowY: "scroll",
  maxHeight: "200px"
};
const DropDownMenu = styled(DropdownMenu)`
  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 2px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 2px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background: #343a40;
  }
  max-height: 100px;
`;
const CheckboxDiv = styled.div`
  padding-top: 8px;
`;
const Wrapper = styled.div`
.percentage{width:100%}
.allocationDiv{display:flex}
.percentageInput{display:flex}
  margin: 0 auto;
  font-family: Trebuchet MS;
  min-width: 940px;
  @media (max-width: 800px) {
    min-width: auto;
  }
  max-width: 1200px;
  padding-left: 10px;
  && label {
    font-size: 12px;
    color: #000;
  }
  && input {
    line-height: 20px;
    padding: 5px 0px;
    background: transparent;
  }
`;
const Column = styled(Col)`
  && {
    font-size: 13px;
    color: #000;
    font-weight: normal;
    text-align: left;
    padding: 10px;
  }
`;
const Timefield = {
  width: "100%",
  position: "relative",
  border: "none",
  borderBottom: "1px solid #6c757d7a",
  outline: "none",
  background: "#f1f4f9",
};
const ColumnNote = styled(Col)`
  width: 25% !important;
  padding-right: 5px !important;
  padding-left: 10px !important;
`;
const RowCont = styled(Row)`{
  && {
    margin:0;
  }
`;
const DateDiv = styled.div``;
const Cont = styled(Container)`
  && {
    max-width: none;
    min-width: 960px;
    @media (max-width: 800px) {
      max-width: 720px;
      min-width: auto;
    }
  }
`;
const DatePickerDiv = styled(DatePicker)`
  background: #f1f4f9;
  border: 1px solid #707070;
  text-align: left;
  width: 120px;
  border: 1px solid #b2b7be;
  height: 28px;
  padding: 5px 10px 5px;
`;
const ImageSpan = styled.div`
  position: relative;
  left: 90px;
  bottom: 24px;
  @media (max-width: 1024px) {
    display: inline-block;
    width: auto;
    left: unset;
    float: right;
    margin-right: 30px;
  }
  @media (max-width: 800px) {
    display: inline-block;
    width: auto;
    left: unset;
    float: right;
    margin-right: 20px;
  }
`;
const Img = styled.img`
  height: 15px;
`;
const Span = styled.div`
  //padding-bottom: 4px;
  padding-left: 1px;
`;
const UserDiv = styled.div`
  border: 2px solid #80808069;
  height: 50%;
  width: 72%;
  @media (max-width: 1024px) {
    width: auto;
    height: auto;
  }
  .userPic {
    @media (max-width: 1024px) {
      width: 100%;
      height: auto;
    }
  }
`;

const FooterDiv = styled.div`
  bottom: 18px;
  padding: 0px;
  text-align: center;
  width: 100%;
  position: absolute;
`;
const Btn = styled.button`
  background: #ffffff;
  border: 1px solid #adb5bd;
  width: 130px;
  height: 35px;
  border-radius: 50px;
  margin-right: 10px;
`;
const BtnSave = styled.button`
  background: #c4151c;
  color: #ffffff;
  border: 1px solid #adb5bd;
  width: 130px;
  height: 35px;
  border-radius: 50px;
  margin-right: 10px;
`;
const StartDateDiv = styled.div`
  .sc-jzgbtB kgFOzF {
    padding-left: 5px !mportant;
  }
  float: left;
`;
const EndDateDiv = styled.div`
  .sc-bHwgHz kiMgLQ {
    bottom: 29px; !important
  }
  float :right
`;
